(function () {
  const SELECTORS = {
    navToggle: "[data-retomas-nav-toggle]",
    navLinks: "[data-retomas-nav-links]",
    reviewTrack: "[data-retomas-review-track]",
    reviewPrev: "[data-retomas-review-prev]",
    reviewNext: "[data-retomas-review-next]",
    locator: "[data-retomas-locator]"
  };

  function initNavigation(scope) {
    scope.querySelectorAll(SELECTORS.navToggle).forEach((button) => {
      if (button.dataset.ready === "true") return;
      const menu = button.closest(".retomas-site-nav").querySelector(SELECTORS.navLinks);
      if (!menu) return;

      button.dataset.ready = "true";
      button.addEventListener("click", () => {
        const isOpen = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isOpen));
        menu.classList.toggle("is-open", !isOpen);
      });

      menu.addEventListener("click", (event) => {
        if (!event.target.closest("a")) return;
        button.setAttribute("aria-expanded", "false");
        menu.classList.remove("is-open");
      });
    });
  }

  function initReviews(scope) {
    scope.querySelectorAll(SELECTORS.reviewTrack).forEach((track) => {
      if (track.dataset.ready === "true") return;
      const section = track.closest(".retomas-reviews");
      const prev = section && section.querySelector(SELECTORS.reviewPrev);
      const next = section && section.querySelector(SELECTORS.reviewNext);
      if (!prev || !next) return;

      const scroll = (direction) => {
        const card = track.querySelector(".retomas-review");
        const distance = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
        track.scrollBy({ left: distance * direction, behavior: "smooth" });
      };

      prev.addEventListener("click", () => scroll(-1));
      next.addEventListener("click", () => scroll(1));
      track.dataset.ready = "true";
    });
  }

  function normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function haversineDistance(lat1, lon1, lat2, lon2) {
    const toRad = (value) => (value * Math.PI) / 180;
    const earthRadiusKm = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps) return Promise.resolve(window.google.maps);
    if (window.retomasGoogleMapsPromise) return window.retomasGoogleMapsPromise;

    window.retomasGoogleMapsPromise = new Promise((resolve, reject) => {
      const callback = "__retomasGoogleMapsReady";
      window[callback] = () => {
        resolve(window.google.maps);
        delete window[callback];
      };

      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(apiKey) +
        "&callback=" +
        callback;
      script.async = true;
      script.defer = true;
      script.onerror = () => reject(new Error("No fue posible cargar Google Maps."));
      document.head.appendChild(script);
    });

    return window.retomasGoogleMapsPromise;
  }

  function initLocator(locator) {
    if (locator.dataset.ready === "true") return;
    locator.dataset.ready = "true";

    const cards = Array.from(locator.querySelectorAll("[data-store-card]"));
    const departmentSelect = locator.querySelector("[data-store-department]");
    const citySelect = locator.querySelector("[data-store-city]");
    const results = locator.querySelector("[data-store-results]");
    const empty = locator.querySelector("[data-store-empty]");
    const locationButton = locator.querySelector("[data-store-location]");
    const mapElement = locator.querySelector("[data-store-map]");
    const tabs = Array.from(locator.querySelectorAll("[data-locator-tab]"));
    const panels = Array.from(locator.querySelectorAll("[data-locator-panel]"));
    const apiKey = locator.dataset.googleMapsKey || "";
    const defaultLat = Number(locator.dataset.defaultLat || 4.711);
    const defaultLng = Number(locator.dataset.defaultLng || -74.0721);
    const defaultZoom = Number(locator.dataset.defaultZoom || 6);
    const markers = new Map();
    let map = null;
    let maps = null;
    let infoWindow = null;
    let userMarker = null;

    function storeData(card) {
      return {
        id: card.dataset.storeId,
        title: card.dataset.storeTitle || "",
        department: card.dataset.storeDepartment || "",
        city: card.dataset.storeCity || "",
        address: card.dataset.storeAddress || "",
        lat: Number(card.dataset.storeLat),
        lng: Number(card.dataset.storeLng),
        directions: card.dataset.storeDirections || ""
      };
    }

    const stores = cards.map(storeData);

    function uniqueValues(key, filter) {
      return Array.from(
        new Set(
          stores
            .filter(filter || (() => true))
            .map((store) => store[key])
            .filter(Boolean)
        )
      ).sort((a, b) => a.localeCompare(b, "es"));
    }

    function fillSelect(select, values, placeholder) {
      if (!select) return;
      const current = select.value;
      select.innerHTML = "";
      const initial = document.createElement("option");
      initial.value = "";
      initial.textContent = placeholder;
      select.appendChild(initial);
      values.forEach((value) => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      if (values.includes(current)) select.value = current;
    }

    function visibleCards() {
      return cards.filter((card) => !card.hidden);
    }

    function updateMarkers() {
      if (!map) return;
      const visibleIds = new Set(visibleCards().map((card) => card.dataset.storeId));
      markers.forEach((marker, id) => marker.setVisible(visibleIds.has(id)));
      const visibleMarkers = Array.from(markers.entries())
        .filter(([id]) => visibleIds.has(id))
        .map(([, marker]) => marker);

      if (visibleMarkers.length === 1) {
        map.setCenter(visibleMarkers[0].getPosition());
        map.setZoom(15);
      } else if (visibleMarkers.length > 1) {
        const bounds = new maps.LatLngBounds();
        visibleMarkers.forEach((marker) => bounds.extend(marker.getPosition()));
        map.fitBounds(bounds, 44);
      }
    }

    function filterStores() {
      const department = normalize(departmentSelect && departmentSelect.value);
      const city = normalize(citySelect && citySelect.value);
      let count = 0;

      cards.forEach((card) => {
        const matchesDepartment =
          !department || normalize(card.dataset.storeDepartment) === department;
        const matchesCity = !city || normalize(card.dataset.storeCity) === city;
        card.hidden = !(matchesDepartment && matchesCity);
        if (!card.hidden) count += 1;
      });

      if (results) {
        results.textContent =
          count === 1 ? "1 tienda encontrada" : count + " tiendas encontradas";
      }
      if (empty) empty.hidden = count !== 0;
      updateMarkers();
    }

    function selectStore(card, focusMap) {
      cards.forEach((item) => item.classList.toggle("is-active", item === card));
      const marker = markers.get(card.dataset.storeId);
      if (map && marker) {
        map.panTo(marker.getPosition());
        map.setZoom(16);
        infoWindow.setContent(
          "<strong>" +
            card.dataset.storeTitle +
            "</strong><br>" +
            card.dataset.storeAddress
        );
        infoWindow.open({ map, anchor: marker });
      }

      if (focusMap && window.matchMedia("(max-width: 749px)").matches) {
        const mapTab = tabs.find((tab) => tab.dataset.lTab === "map");
        if (mapTab) mapTab.click();
      }
    }

    fillSelect(departmentSelect, uniqueValues("department"), "Todos los departamentos");
    fillSelect(citySelect, uniqueValues("city"), "Todas las ciudades");

    if (departmentSelect) {
      departmentSelect.addEventListener("change", () => {
        const selected = departmentSelect.value;
        fillSelect(
          citySelect,
          uniqueValues("city", (store) => !selected || store.department === selected),
          "Todas las ciudades"
        );
        filterStores();
      });
    }

    if (citySelect) citySelect.addEventListener("change", filterStores);

    cards.forEach((card) => {
      const selector = card.querySelector("[data-store-select]");
      if (selector) selector.addEventListener("click", () => selectStore(card, true));
    });

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const target = tab.dataset.lTab;
        tabs.forEach((item) =>
          item.setAttribute("aria-selected", String(item === tab))
        );
        panels.forEach((panel) => {
          panel.classList.toggle("is-mobile-active", panel.dataset.lPanel === target);
        });
        if (target === "map" && map) {
          window.google.maps.event.trigger(map, "resize");
          updateMarkers();
        }
      });
    });

    panels.forEach((panel) => {
      panel.classList.toggle("is-mobile-active", panel.dataset.lPanel === "list");
    });

    if (locationButton) {
      locationButton.addEventListener("click", () => {
        if (!navigator.geolocation) {
          locationButton.textContent = "Ubicación no disponible";
          return;
        }

        locationButton.disabled = true;
        locationButton.textContent = "Buscando ubicación…";
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            cards.sort((a, b) => {
              const storeA = storeData(a);
              const storeB = storeData(b);
              return (
                haversineDistance(userLat, userLng, storeA.lat, storeA.lng) -
                haversineDistance(userLat, userLng, storeB.lat, storeB.lng)
              );
            });
            const list = locator.querySelector("[data-store-list]");
            cards.forEach((card) => list.appendChild(card));

            cards.forEach((card) => {
              const store = storeData(card);
              const distance = haversineDistance(userLat, userLng, store.lat, store.lng);
              const label = card.querySelector("[data-store-distance]");
              if (label && Number.isFinite(distance)) {
                label.textContent = distance.toFixed(1) + " km de distancia";
                label.hidden = false;
              }
            });

            if (map && maps) {
              if (userMarker) userMarker.setMap(null);
              userMarker = new maps.Marker({
                map,
                position: { lat: userLat, lng: userLng },
                title: "Tu ubicación",
                icon: {
                  path: maps.SymbolPath.CIRCLE,
                  scale: 8,
                  fillColor: "#075cff",
                  fillOpacity: 1,
                  strokeColor: "#ffffff",
                  strokeWeight: 3
                }
              });
              map.panTo({ lat: userLat, lng: userLng });
              map.setZoom(12);
            }

            locationButton.disabled = false;
            locationButton.textContent = "Ordenadas por cercanía";
          },
          () => {
            locationButton.disabled = false;
            locationButton.textContent = "No se permitió la ubicación";
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
      });
    }

    filterStores();

    if (!apiKey) {
      if (mapElement) {
        mapElement.innerHTML =
          '<div class="retomas-map-message">Configura la clave de Google Maps en esta sección para activar el mapa.</div>';
      }
      return;
    }

    loadGoogleMaps(apiKey)
      .then((googleMaps) => {
        maps = googleMaps;
        map = new maps.Map(mapElement, {
          center: { lat: defaultLat, lng: defaultLng },
          zoom: defaultZoom,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true
        });
        infoWindow = new maps.InfoWindow();

        stores.forEach((store) => {
          if (!Number.isFinite(store.lat) || !Number.isFinite(store.lng)) return;
          const marker = new maps.Marker({
            map,
            position: { lat: store.lat, lng: store.lng },
            title: store.title
          });
          markers.set(store.id, marker);
          marker.addListener("click", () => {
            const card = cards.find((item) => item.dataset.storeId === store.id);
            if (card) {
              card.hidden = false;
              card.scrollIntoView({ block: "nearest", behavior: "smooth" });
              selectStore(card, false);
            }
          });
        });

        updateMarkers();
      })
      .catch(() => {
        mapElement.innerHTML =
          '<div class="retomas-map-message">No fue posible cargar el mapa. Revisa la clave y sus restricciones de dominio.</div>';
      });
  }

  function init(scope) {
    initNavigation(scope);
    initReviews(scope);
    scope.querySelectorAll(SELECTORS.locator).forEach(initLocator);
  }

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
